import * as React from 'react'
import ProviderProductList from '../../containers/products/ProviderProductList'
import { IProviderProductActivateProductModal, IProviderProductDeleteProductModal } from '../../types/index'

interface IProviderProductDeactivatedListPaneProps {
  deleteProductModal: IProviderProductDeleteProductModal
  activateProductModal: IProviderProductActivateProductModal
}

const ProviderProductDeactivatedListPane = (props: IProviderProductDeactivatedListPaneProps) => {
  return (
    <React.Fragment>
      <ProviderProductList type='deactivated' />
    </React.Fragment>
  )
}

export default ProviderProductDeactivatedListPane



// WEBPACK FOOTER //
// ./src/components/products/ProviderProductDeactivatedListPane.tsx